import React from 'react';
import ReportRunner from './ReportRunner';

export default function Reports() {
  return <ReportRunner />;
}
